import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import EmployeeItem from './Components/EmployeeItem'

class EmployeeSearchResult extends Component {
  static propTypes = {
    employeeSearchStore: PropTypes.object,
    employeeStore: PropTypes.object,
    history: PropTypes.object
  }

  onLink = (e, id) => {
    e.preventDefault()
    this.props.history.push('/employee-search/employee/' + id)

    const { employeeSearchStore, employeeStore } = this.props
    employeeSearchStore.selectedEmployee = id
    employeeStore.get(id)
  }

  render () {
    const {
      employees,
      employeesCount,
      selectedEmployee
    } = this.props.employeeSearchStore
    return (
      <div>
        <div className='expert-search-header no-of-contacts'>
          <h4 className='expert-search-total'>
            {employeesCount} employees
            {!employeesCount && (
              <span className='expert-search-total-message'>
                {' '}
                match the current search parameters
              </span>
            )}
          </h4>
        </div>
        {employees.map(employee => (
          <EmployeeItem
            key={employee.id}
            employee={employee}
            selected={selectedEmployee === employee.id}
            onLink={this.onLink}
          />
        ))}
      </div>
    )
  }
}

export default withRouter(
  inject('employeeStore', 'employeeSearchStore')(observer(EmployeeSearchResult))
)
